import Icons from "../assets/icon/index";

const CategoriesBtnData = [
    {
        id: 1,
        BtnTitle: "Book a Talent",
        btnIcon: Icons.BookaTalentIcon,
    },
    {
        id: 2,
        BtnTitle: "Sell Your Services",
        btnIcon: Icons.SellYourServicesIcon,
    },
    {
        id: 3,
        BtnTitle: "Creative Collaborations",
        btnIcon: Icons.CreativeCollaborationsIcon,
    },
    {
        id: 4,
        BtnTitle: "Pitch Your Film Projects",
        btnIcon: Icons.PitchYourFilmProjectsIcon,
    },
    {
        id: 5,
        BtnTitle: "Sign Talent & Creators",
        btnIcon: Icons.SignTalentCreatorsIcon,
    },
    {
        id: 5,
        BtnTitle: "Support New Talent",
        btnIcon: Icons.SupportNewTalentIcon,
    },
];
export default CategoriesBtnData;